import * as yup from 'yup'

const validationSchema = (t) =>
  yup.object().shape({
    url: yup
      .string()
      .url(t('article.form.error.urlReg'))
      .required(t('article.form.error.url')),
    urlEn: yup.string().when('url', {
      is: (url) => url, // alternatively: (val) => val == true
      then: yup.string().url(t('article.form.error.urlReg')).notRequired(),
      otherwise: yup
        .string()
        .url(t('article.form.error.urlReg'))
        .required(t('article.form.error.url')),
    }),
  })

export default validationSchema
